<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.service_types_requests_show") }}</h4>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <v-row>
            <v-col cols="12">
              <div class="preview-container text-center my-3 col-6 m-auto" v-if="data.image.path">
                <p class="mb-3" style="color:#F7941E; font-size: 16px; font-weight: bold;">{{ $t("PLACEHOLDERS.service_type_request_image") }}</p>
                <img
                  v-if="data.image.path"
                  col="6"
                  :src="data.image.path"
                  :alt="$t('PLACEHOLDERS.service_type_request_image')"
                />
              </div>
            </v-col>
          </v-row>
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.provider_name')"
            v-model.trim="data.name"
            disabled
          />
          <!-- End:: Name Input -->
          <!-- start phone tel -->

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model="data.phone"
            disabled
            style="direction: ltr; text-align: left"
          />

          <!-- end phone tel -->
          <!-- Start:: email Input -->
          <base-input
            col="6"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            type="email"
            disabled
            v-if="data.email"
          />
          <!-- End:: email Input -->

          <base-input
            col="6"
            :placeholder="$t('PLACEHOLDERS.city')"
            v-model.trim="data.city"
            type="text"
            disabled
          />

          <!-- <h3>{{ $t("PLACEHOLDERS.service_type_data") }}</h3> -->
          <!-- Start:: request_number Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.request_number')"
            v-model.trim="data.id"
            disabled
          />
          <!-- End:: request_number Input -->

          <!-- Start:: created_at Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.created_at')"
            v-model.trim="data.created_at"
            disabled
          />
          <!-- End:: created_at Input -->

         <!-- Start:: service_type Input -->
         <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.serviceName')"
            v-model.trim="data.service_name"
            disabled
          />
          <!-- End:: request_number Input -->

          <!-- Start:: created_at Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.status')"
            v-model.trim="data.status_translation"
            disabled
          />
          <!-- End:: created_at Input -->

          <div style="pointer-events: none">
            <MapComponent
              :lat="parseFloat(data.latitude)"
              :lng="parseFloat(data.longitude)"
              @update:lat="data.latitude = $event"
              @update:lng="data.longitude = $event"
              class="mb-5"
              disabled
            />
          </div>
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import UploadsPhotos from "../../../components/formInputs/UploadsPhotos.vue";
import MapComponent from "@/components/general/MapComponent";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "CreateCity",

  components: {
    UploadsPhotos,
    MapComponent,
  },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      EnRegex: /[\u0600-\u06FF]/,

      // Start:: Data Collection To Send
      data: {
        image: {
          path: "",
          file: "",
        },
        salon_image: {
          path: "",
          file: "",
        },
        name: null,
        phone: null,
        email: null,
        password: null,
        passwordConfirmation: null,
        salon_name_ar: null,
        salon_name_en: null,
        salon_description_ar: null,
        salon_description_en: null,
        commercial_register: null,
        salon_number: null,
        active: true,
        registered_in_marouf: 0,
        main_section: null,
        marouf: null,
        sub_section: null,
        region: null,
        WhatsApp_contact: null,
        twitter_link: null,
        snap_link: null,
        insta_link: null,
        latitude: 24.7136,
        longitude: 46.6753,
        id: null,
        created_at: null,
        status_translation: null,
        service_name: null,
      },

      phones: [],
      days: [],

      mapOptions: {
        zoomControl: false, // Disable the default zoom control
        disableDoubleClickZoom: true, // Disable zooming on double-click
        draggable: false, // Disable dragging the map
        clickableIcons: false, // Disable clickable icons on the map
        // More options can be added if required
      },

      additionalImages: [],
      imgUrls: [],
      main_sections: [],
      sub_sections: [],
      regions: [],

      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
      getCountriesData: "ApiGetsModule/allCountriesData",
    }),
  },

  methods: {
    onFileSelect(files) {
      this.additionalImages = files;
    },
    onFileRemove(index) {
      this.$delete(this.imgUrls, index);
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();

      // if (!this.data.nameAr) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.nameAr"));
      //   return;
      // } else if (!this.data.nameEn) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.nameEn"));
      //   return;
      // } else {
      //   return;
      // }
    },
    countryChanged(country) {
      this.data.dialCode = country.dialCode;
      this.data.code = country.iso2;
      console.log(country);
    },
    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },
    // End:: validate Form Inputs
    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    selectImageSalon(selectedImage) {
      this.data.salon_image = selectedImage;
    },
    // End:: Select Upload Image
    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();

      if (this.data.image.file) {
        REQUEST_DATA.append("user[avatar]", this.data.image.file);
      }

      if (this.data.salon_image.file) {
        REQUEST_DATA.append("salon[logo]", this.data.salon_image.file);
      }

      if (this.data.phone) {
        REQUEST_DATA.append("user[name]", this.data.phone);
      }

      if (this.data.mobile) {
        REQUEST_DATA.append("user[mobile]", this.data.mobile);
      }

      if (this.data.email) {
        REQUEST_DATA.append("user[email]", this.data.email);
      }

      if (this.data.password) {
        REQUEST_DATA.append("user[password]", this.data.password);
      }

      if (this.data.passwordConfirmation) {
        REQUEST_DATA.append(
          "user[password_confirmation]",
          this.data.passwordConfirmation
        );
      }

      if (this.data.salon_name_ar) {
        REQUEST_DATA.append("salon[name][ar]", this.data.salon_name_ar);
      }

      if (this.data.salon_name_en) {
        REQUEST_DATA.append("salon[name][en]", this.data.salon_name_en);
      }

      if (this.data.salon_description_ar) {
        REQUEST_DATA.append(
          "salon[description][ar]",
          this.data.salon_description_ar
        );
      }
      if (this.data.salon_description_en) {
        REQUEST_DATA.append(
          "salon[description][en]",
          this.data.salon_description_en
        );
      }

      if (this.data.latitude) {
        REQUEST_DATA.append("salon[lat]", this.data.latitude);
      }

      if (this.data.longitude) {
        REQUEST_DATA.append("salon[long]", this.data.longitude);
      }

      if (this.data.commercial_register) {
        REQUEST_DATA.append(
          "salon[commercial_number]",
          this.data.commercial_register
        );
      }

      if (this.data.salon_number) {
        REQUEST_DATA.append("salon[number]", this.data.salon_number);
      }

      if (this.additionalImages && this.additionalImages.length > 0) {
        this.additionalImages.forEach((file, index) => {
          REQUEST_DATA.append(`salon[images][${index}]`, file);
        });
      }

      if (this.data.main_section) {
        this.data.main_section.forEach((element, index) => {
          REQUEST_DATA.append(`salon[category_ids][${index}]`, element?.id);
        });
      }

      if (this.data.sub_section) {
        this.data.sub_section.forEach((element, index) => {
          REQUEST_DATA.append(`salon[sub_category_ids][${index}]`, element?.id);
        });
      }

      if (this.data.region) {
        REQUEST_DATA.append("salon[region_id]", this.data.region?.id);
      }

      REQUEST_DATA.append(
        "salon[maroof_number]",
        +this.data.registered_in_marouf
      );

      // REQUEST_DATA.append("is_active", is_active);
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `accepted-providers`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/providers/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
    data: {
      salon_number: null,
      active: true,
      registered_in_marouf: 0,
      main_section: null,
      sub_section: null,
      region: null,
      latitude: 24.7136,
      longitude: 46.6753,
    },

    // start show data
    async showData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `provider-types/requests?id=${this.$route.params.id}`,
        });
        console.log(res.data.data);
        this.data.image.path = res.data.data.data[0]?.user?.avatar;
        this.data.name = res.data.data.data[0]?.user?.name;
        this.data.phone = res.data.data.data[0]?.user?.country_code+res.data.data.data[0]?.user?.mobile;
        this.data.email = res.data.data.data[0]?.user?.email;
        this.data.city = res.data.data.data[0]?.user?.city;
        this.data.id = res.data.data.data[0]?.id;
        this.data.created_at = res.data.data.data[0]?.created_at;
        this.data.service_name = res.data.data.data[0]?.name;
        this.data.status_translation = res.data.data.data[0]?.status_translation;
        this.data.latitude = +res.data.data.data[0]?.user?.latitude;
        this.data.longitude = +res.data.data.data[0]?.user?.longitude;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end show data
  },

  created() {
    this.showData();
  },
};
</script>

<style lang="scss" scoped>
.images {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;

  .image {
    width: 150px;
    height: 150px;
    img {
      object-fit: cover;
      border-radius: 20px;
      width: 100%;
      height: 100%;
    }
  }
}

@media (max-width: 767px) {
  .items {
    > div {
      width: 100%;
    }
  }
}
</style>
